<!-- 삭제 -->
<template>
  <div>
    <admin-form-item>
      <div v-for="item in value.file"
           style="display: flex; flex-wrap: wrap; justify-content: center"
           v-if="value.file_type==='img'">
        <div :style="imgStyle(item)"></div>
      </div>
      <div v-for="item in value.file"
           v-if="value.file_type==='file'"
           style="text-align: center">
        <a :href="item">{{item}}</a>
      </div>
    </admin-form-item>
  </div>
</template>

<script>
  export default {
    props:['data'],
    components: {
    },
    data () {
      return {
        value: {
          file: '',
          file_type: ''
        }
      }
    },
    created(){
      this.value = this.data;
    },
    watch:{
      data(n){
        if(n){
          this.value = n;
        }
      }
    },
    computed : {

    },
    methods: {
      imgStyle(item) {
        return 'background-image: url(' + item + ');' +
          'background-size: cover; width: 200px; height: 200px';
      },
      cancelModal(){
        this.$store.commit('cancelModal');
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
